import { render, staticRenderFns } from "./compression-info.vue?vue&type=template&id=234e7438&scoped=true"
import script from "./compression-info.vue?vue&type=script&lang=js"
export * from "./compression-info.vue?vue&type=script&lang=js"
import style0 from "./compression-info.vue?vue&type=style&index=0&id=234e7438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e7438",
  null
  
)

export default component.exports